
    import Vue from 'vue'

    import Chart from '@/components/visualization/Chart.vue';
    import DeviceInfoDialog from '@/components/entities/device/DeviceInfoDialog.vue';
    import ReadingService from '@/services/ReadingService';
    import { autoComplete } from '@/utils/Util';
    import TimeRangeFilter from '../filters/TimeRangeFilter.vue';
    import AggregationIntervalFilter from '../filters/AggregationIntervalFilter.vue';
    import SelectionFilter from '../filters/SelectionFilter.vue';
    import { ReadingAggregationFrequencies, ReadingAggregationFunctions } from '../entities/reading/ReadingCollections';

    export default Vue.extend({
        name: 'ChartCard',

        components: {
            Chart,
            DeviceInfoDialog,
            TimeRangeFilter,
            AggregationIntervalFilter,
            SelectionFilter
        },
        props: ['item', 'index'],
        data: (vm: any): any => ({
            loadingDevices: false,
            requiredSelect: [
                (v: any) => (!!v && Object.keys(v).length > 0) || vm.requiredError
            ],
            loading: false,
            chartData: [],
            selectedChartType: vm?.item?.config?.type || "bar",
            // selectedTimeRange: vm?.item?.config?.timeRange || { value: "1m", label: "1 " + vm.$t('timeUnit.month'), interval: "1", frequency: "DAILY" },
            selectedFunction: vm?.item?.config?.function || "Max",
            timeFunctions: ["Avg", "Sum", "Min", "Max", "Diff", "Consumption"],
            selectedAggregation: vm.item.config.aggregation ?? { aggregationInterval: 1,  aggregationFrequency: 'DAILY' } as any,
            timeFrequencies: ReadingAggregationFrequencies,
        }),
        async created() {
            if(this.index && parseInt(this.index))
                await this.delay(parseInt(this.index)*100);

            if(!('from' in this.selectedAggregation) && !('until' in this.selectedAggregation)) {
                const until = new Date();
                const from = new Date();
                from.setUTCMonth(until.getUTCMonth()-6);
                this.selectedAggregation.from = from.toISOString();
                this.selectedAggregation.until = until.toISOString();
            }

            this.getData();
        },
        watch: {
            selectedChartType(): any {
                this.onConfigChange();
            },
            selectedAggregation(): any {
                this.onConfigChange();
                this.getData();
            },
            selectedFunction(): any {
                this.onConfigChange();
                this.getData();
            },
        },
        methods: {
            delay(ms: number) {
                return new Promise(res => setTimeout(res, ms));
            },
            onChartDownload() {
                // s
            },
            onDelete() {
                this.$emit('delete', this.item);
            },
            onRefresh() {
                this.getData();
            },
            onShowReadings() {
                this.$router.push({ name: 'Readings', params: { device: this.item.device } });
            },    
            onConfigChange() {
                let citem = { ...this.item, config:{ type: this.selectedChartType, aggregation: this.selectedAggregation, function: this.selectedFunction } }
                this.$emit('update:item', citem);
            },
            autoComplete,
            async getData() {
                this.loading = true;

                let aggregationFrom = this.selectedAggregation.from;
                let aggregationUntil = this.selectedAggregation.until;

                if(!aggregationFrom || !aggregationUntil) {
                    this.loading = false;
                    return;
                }

                let aggregationInterval = this.selectedAggregation.aggregationInterval;
                let aggregationFrequency = this.selectedAggregation.aggregationFrequency;
                let aggregationFunction = this.selectedFunction;


                try {
                    this.chartData = await ReadingService.getAllAggregationPages(this.currentTenant, this.item.device.uuid, aggregationInterval, aggregationFrequency, aggregationFunction, { from: aggregationFrom, until: aggregationUntil });
                    // console.log(this.chartData);
                } catch(error) {
                    console.log(error);
                }
                this.loading = false;
            }
        },
        computed: {
            requiredError(): any {
                return this.$t('required');
            },
            currentTenant(): any {
                return this.$root.$store.state.session.selectedTenant.uuid;
            },
            timeUnits(): any[] {
                return [
                {name: this.$t('timeUnit.minutes'), frequency: 'MINUTELY' },
                {name: this.$t('timeUnit.hours'), frequency: 'HOURLY'}, 
                {name: this.$t('timeUnit.days'), frequency: 'DAILY'},
                {name: this.$t('timeUnit.weeks'), frequency: 'WEEKLY'},
                {name: this.$t('timeUnit.months'), frequency: 'MONTHLY'},
                {name: this.$t('timeUnit.years'), frequency: 'YEARLY'}
            ]
            },
            timeRanges(): any[] {
                return [
                    { value: "1h", label: "1 " + this.$t('timeUnit.hours'), interval: "1", frequency: "MINUTELY" },
                    { value: "6h", label: "6 " + this.$t('timeUnit.hours'), interval: "15", frequency: "MINUTELY" },
                    { value: "12h", label: "12 " + this.$t('timeUnit.hours'), interval: "15", frequency: "MINUTELY" },
                    { value: "1d", label: "1 " + this.$t('timeUnit.day'), interval: "1", frequency: "HOURLY" },
                    { value: "1w", label: "1 " + this.$t('timeUnit.week'), interval: "1", frequency: "DAILY" },
                    { value: "1m", label: "1 " + this.$t('timeUnit.month'), interval: "1", frequency: "DAILY" },
                    { value: "6m", label: "6 " + this.$t('timeUnit.months'), interval: "1", frequency: "WEEKLY" },
                    { value: "1y", label: "1 " + this.$t('timeUnit.year'), interval: "1", frequency: "MONTHLY" },
                    { value: "3y", label: "3 " + this.$t('timeUnit.years'), interval: "1", frequency: "MONTHLY" },
                ];
            }
        },
    })
